export function DraftQueue() {
  return (
    <div className="container mx-auto max-w-7xl px-6 py-10">
      <header>
        <p className="text-xs font-semibold uppercase tracking-widest text-primary">Monday queue</p>
        <h1 className="mt-1 text-3xl font-bold tracking-tight">Draft queue</h1>
        <p className="mt-2 text-muted-foreground">
          AI-drafted re-engagement emails grouped by assignee. Review · edit · send · skip.
        </p>
      </header>

      <div className="mt-8 rounded-xl border border-dashed border-border bg-card p-10 text-center">
        <p className="text-sm font-medium">Empty queue</p>
        <p className="mt-2 text-sm text-muted-foreground">
          Wires in W3 to <code>GET /api/drafts?status=Pending</code>.
        </p>
      </div>
    </div>
  );
}
